import React, { useContext, useEffect, useState } from "react";
import { ReportingUserTimelineNew } from "./ReportingUserTimelineNew";
import { UserUMS } from "../../types/Users";
import { useReportingUserStore } from "../../storez/ReportingUserStore";
import { ResponseError } from "../../types/Api";
import { Flex, Spinner, useToast, useTranslation } from "@familyzone/component-library";
import { InjectedRouter } from "react-router";
import { ReactRouterCompatContext } from "../ContextProvider";
import { ApiDates } from "../../utils/DateTimeUtil";

/**
 * Date ranges for the ReportingUserTimelineNew has two behaviours:
 *    1. When `date` parameter is passed, the timeline is loaded from start of the day to the end of the day
 *    2. When `end_date` and `end_time` are passed, the timeline would load the 48H of data from the end time.
 *         This behaviour is only present if you open navigate to the user timeline from user dashboard
 */

const ReportingUserTimeline: React.FC<{
  location?: {
    query?: ApiDates & {
      date?: string;
      /**
       * @deprecated: use {@code endDate} instead
       */
      end_date?: string;
      /**
       * @deprecated: use {@code endTime} instead
       */
      end_time?: string;
      filter_type?: string;
    };
  };
  params: {
    // Qoria user ID (UUID) or username
    user: string;
  };
}> = ({ location, params }) => {
  const { router } = useContext(ReactRouterCompatContext) as { router: InjectedRouter };
  const { errorToast } = useToast();
  const { t } = useTranslation();

  const [user, setUser] = useState<UserUMS>();

  const endDate = location?.query?.endDate || location?.query?.end_date,
    endTime = location?.query?.endTime || location?.query?.end_time;

  useEffect(() => {
    setUser(undefined);

    void useReportingUserStore
      .getState()
      .getUser(params.user)
      .then(setUser, (err: ResponseError) => {
        if ("status" in err && (err.status === 403 || err.status === 404)) {
          router.replace("/config/device/forbidden");
        } else {
          errorToast({
            title: t("Please try again"),
            description: t("Failed to load student data. If the issue persists, please contact support."),
            isClosable: true,
          });
        }
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.user]);

  if (!user) {
    return (
      <Flex minHeight="200px" alignItems="center" justifyContent="center">
        <Spinner size="md" />
      </Flex>
    );
  }

  return (
    <ReportingUserTimelineNew
      user={user}
      date={location?.query?.date}
      end_date={endDate}
      end_time={endTime}
      filter_type={location?.query?.filter_type}
    />
  );
};

export default ReportingUserTimeline;
